import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import "../../assets/styles/local/WorkflowAutomation.css";

import TemplateBuilderIcon from "../../assets/icons/TemplateBuilder.svg";
import deleteIco from "../../assets/icons/TemplateBuilder/Bin.svg";
import editIco from "../../assets/icons/TemplateBuilder/edit.svg";
import { useHistory } from "react-router-dom";

import {
  FetchWorkflowByCompany,
  DeleteWorkflowById,
} from "../../redux/actions/workflowAutomationActions";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const WorkflowList = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Workflow-Automation-List").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  useEffect(() => {
    dispatch(FetchWorkflowByCompany());
  }, []);

  const workFlowData = useSelector((state) => state.user.workflowList);
  const [workFlowList, setWorkflowList] = useState([]);

  useEffect(() => {
    if (workFlowData && workFlowData.status) {
      setWorkflowList(workFlowData.data);
    }
  }, [workFlowData]);

  const deleteWorkflow = (workflowId) => {
    DeleteWorkflowById(workflowId).then(
      (res) => {
        dispatch(FetchWorkflowByCompany());
      },
      (err) => {
        console.log(err);
      }
    );
  };
  //pagination code start here
  const [paginationObj, setPaginationObj] = useState({
    totalRecords: 0,
    currentPage: 0,
    startRecordIndex: 0,
    endRecordIndex: 0,
    totalPages: 0,
    records: [],
  });

  const itemsPerPage = 10;

  const calculatePagination = (pageNumber) => {
    let records = workFlowList || [];
    let tempPaginationObj = {
      totalRecords: records.length,
      currentPage: pageNumber,
      startRecordIndex: Math.max(itemsPerPage * (pageNumber - 1) + 1, 1),
      endRecordIndex: Math.min(itemsPerPage * pageNumber, records.length),
      totalPages: Math.ceil(records.length / itemsPerPage),
      records: records.slice(
        (pageNumber - 1) * itemsPerPage,
        pageNumber * itemsPerPage
      ),
    };
    setPaginationObj({ ...paginationObj, ...tempPaginationObj });
  };
  useEffect(() => {
    calculatePagination(1);
  }, [workFlowList]);
  //pagination code end  here

  return (
    <>
      <Row className="border-bottom mb-2">
        <Col xl={6} className="workflow-list-header">
          {/* All Templates */}
          {t("All templates")}
        </Col>
        <Col xl={6} className="text-end">
          {/* {`1-${workFlowList.length} of 1 <1>`} */}
          <div className="stock-custom-pagination">
            <div>
              {`${paginationObj.startRecordIndex} - ${paginationObj.endRecordIndex}  of  ${paginationObj.totalRecords}`}
            </div>
            <div className="pagination-buttons">
              <div
                className={`update-stock-pagination-button ${
                  paginationObj.currentPage === 1 ? "disabled" : ""
                }`}
                onClick={() =>
                  calculatePagination(paginationObj.currentPage - 1)
                }
              >
                <BsChevronLeft />
              </div>
              <div className="pagination-current-page">
                {paginationObj.currentPage}
              </div>
              <div
                className={`update-stock-pagination-button ${
                  paginationObj.totalPages === 0 ||
                  paginationObj.totalPages === paginationObj.currentPage
                    ? "disabled"
                    : ""
                }`}
                onClick={() =>
                  calculatePagination(paginationObj.currentPage + 1)
                }
              >
                <BsChevronRight />
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* {workFlowList != null && workFlowList.length > 0 && workFlowList.map((o) => ( */}
      {paginationObj.records != null &&
        paginationObj.records.length > 0 &&
        paginationObj.records.map((o) => (
          <Row className="border-bottom-dotted" key={o.workFlowId}>
            <Col xl={6}>
              <img
                src={TemplateBuilderIcon}
                className="workflow-item-icon cursor-pointer"
                alt="workflow"
              />{" "}
              &nbsp;
              {o.workFlowName}
            </Col>
            <Col xl={6} className="text-end">
              <img
                src={editIco}
                alt="Edit"
                className="cursor-pointer"
                onClick={() => {
                  history.push(`/update-workflow-automation/${o.workFlowId}`);
                }}
              />{" "}
              &nbsp;&nbsp;&nbsp;
              <img
                src={deleteIco}
                alt="Delete"
                className="cursor-pointer"
                onClick={() => {
                  deleteWorkflow(o.workFlowId);
                }}
              />
            </Col>
          </Row>
        ))}

      {paginationObj.records && paginationObj.records.length === 0 && (
        <span>
          {/* No workflows.{" "} */}
          {t("No workflows")}.{" "}
          <a
            className="worflow-create-anchor cursor-pointer"
            onClick={() => {
              history.push("/add-workflow-automation");
            }}
          >
            {/* Let's start creating */}
            {t("Let's start creating")}
          </a>
          .
        </span>
      )}
    </>
  );
};

export default WorkflowList;
